import {
  DEFAULT_BLACK_IMAGE_PATH,
} from '../../../scripts/Routes/images.js';

export const books = {
  '2024': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Innovators by Walter Isaacson',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Make Your Bed by Admiral William H. McRaven',
      'url': '#',
    },
  ],
  '2023': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Understanding Business',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Heart of Business',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Elon Musk by Walter Isaacson',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Fear and Loathing in Las Vegas',
      'url': '#',
    },
  ],
  '2022': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Harry Potter and the Sorcerer Stone',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Contrarian',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Chronicles of San Francisco',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Founders',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Neither Here nor There: Travels in Europe by Bill Bryson',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Little Prince by Antoine de Saint-Exupéry',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Build by Tony Fadell',
      'url': '#',
    },
  ],
  '2021': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Yearbook by Seth Rogen',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'A Promised Land by Barack Obama',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The 7 Habits of Highly Effective People',
      'url': '#',
    },
  ],
};
